import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { Provider } from 'react-redux';
import { useEffect } from 'react';
import { store, resetGame } from './store/gameStore';
import { PlinkoGame } from './components/PlinkoGame';
import theme from './theme/theme';

function App() {
  // Reset game state on mount to ensure fresh start
  useEffect(() => {
    store.dispatch(resetGame());
  }, []);

  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        
        <PlinkoGame />
      </ThemeProvider>
    </Provider>
  );
}

export default App;